import Vue from "vue"

const getUserConfig = () => ({
  signedIn: window.config.userSignedIn,
  isArtist: window.config.userRole === "artist",
  tradeAccountStatus: window.config.tradeAccountStatus,
  // Prevent window object changes for sensitive variables
  isAdmin: document.querySelector('meta[name="isAdmin"]').getAttribute("content") === "true",
})

const userConfigGlobalState = Vue.observable({
  userConfig: getUserConfig(),
})

window.reloadUserConfig = () => {
  userConfigGlobalState.userConfig = getUserConfig()
}

export default {
  install: function (Vue, _options) {
    return Vue.mixin({
      data: () => ({
        appConfig: {
          marketEmail: window.config.marketEmail,
        },
      }),
      computed: {
        userConfig: {
          get() {
            return userConfigGlobalState.userConfig
          },
          set(value) {
            userConfigGlobalState.userConfig = value
          },
        },
      },
    })
  },
}
